import store from '../../store';
import * as projectsActionTypes from '../../redux/projects/actionTypes.projects';

export async function connectAlanTutor(userData?) {
    return new Promise(function (resolve, reject) {
        if (window.tutor) {
            window.tutor.close();
        }

        window.tutor = window.alan.tutor(userData);

        window.tutor.on('connectStatus', (status) => {
            console.info('ALAN: connectStatus', status)
            store.dispatch({
                type: projectsActionTypes.UPDATE_STUDIO_CONNECT_DETAILS_OK,
                connectionDetails: { status }
            });
            if ((userData && status === 'authorized') || (!userData && status === 'connected')) {
                resolve(status);
            } else {
                reject(status);
            }
        });
    });
}
